<template>
  <transition name="slide-fade">
    <div
      v-if="active"
      class="navbar-dropdown"
      :class="rootClasses"
    >
      <div v-if="title">
        <div class="navbar-dropdown-title">
          <span class="ota-small-light" v-text="title" />
          <div class="w-4 border-b-2 mt-1 border-primary" />
        </div>
        <hr class="mt-5 border-gray-100">
      </div>
      <div v-if="buttonLink" class="px-4 py-5 bg-gray-100">
        <OButton
          size="sm"
          class="w-full"
          @click="$router.push(buttonLink)"
        >
          {{ $t(buttonText) }}
        </OButton>
      </div>
      <div v-if="$slots.default">
        <slot />
      </div>
      <div
        v-else
        class="mt-4"
      >
        <div
          v-for="item in items"
          :key="item.text"
          class="navbar-dropdown-item"
          @click="$router.push($i18n.localePath({ name: item.path }))"
        >
          <OSvg v-if="item.icon" :svg="item.icon" class="mr-2 w-5 h-auto" :class="item.iconClasses" />
          <span v-t="item.text" class="whitespace-no-wrap ota-body-light" />
        </div>
      </div>      <slot name="footer" />
    </div>
  </transition>
</template>

<script>
const OSvg = () => import('@/components/OSvg')
const OButton = () => import('@/components/OButton/OButton')

export default {
  name: 'NavDropdown',
  components: { OButton, OSvg },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: 'md',
      validator: value => ['md', 'lg'].some(size => size === value)
    },
    items: {
      type: Array,
      default: () => ([])
    },
    buttonLink: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: ''
    }
  },
  computed: {
    rootClasses () {
      return this.size
    }
  }
}
</script>

<style lang="postcss" scoped>
  .navbar-dropdown {
    @apply shadow rounded absolute right-0 mt-3 bg-white -mr-2;

    &.md {
      width: 26.1rem;
    }

    &.lg {
      width: 32.1rem;
    }

    .navbar-dropdown-title {
      @apply px-7 mt-4;
    }

    .navbar-dropdown-item {
      @apply flex items-center py-2 px-5 mb-1 cursor-pointer;

      &:hover {
        @apply bg-gray-100;
      }
    }
  }

  .slide-fade-enter-active {
    @apply transition-all duration-150 ease-in-out;
  }
  .slide-fade-leave-active {
    @apply transition-all duration-150 ease-in-out;
  }
  .slide-fade-enter, .slide-fade-leave-to {
    @apply opacity-0;
    transform: translateY(-25px);
  }
</style>
